export default __webpack_public_path__ + "static/media/paypal3.456e1bd6.png";